import { render, staticRenderFns } from "./_Regions.vue?vue&type=template&id=e17f01ee&"
import script from "./_Regions.vue?vue&type=script&lang=ts&"
export * from "./_Regions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports